module.exports = __webpack_public_path__ + "img/consult_info5.ce123850.png";